export default "__VITE_ASSET__bULEsj4N__"